import { createFileRoute } from "@tanstack/react-router";
import Pricing from "@/pages/Pricing";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/pricing/")({
  head: () => routeHead("/pricing/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Pricing />
  );
}
